import { ucfirst } from '~/helpers'
import { steps as newReferralSteps } from 'mixins/ReferralsNewPageMixin'
import RequireUserMiddleware from 'middlewares/RequireUserMiddleware'
import RequireSignupFinishedMiddleware from 'middlewares/RequireSignupFinishedMiddleware'
import RequirePhysicianOrAncillaryMiddleware from 'middlewares/RequireSignupFinishedMiddleware'

export default [
    ...['received', 'made'].map((type) => ({
        path: `/referrals/${type}`,
        name: `referrals.${type}`,
        view: 'referrals/tracking/Index',
        default: { query: { state: 'all', limit: 10 }, params: { type } },
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryMiddleware, RequireUserMiddleware],
    })),
    ...['received', 'made'].map((type) => ({
        path: `/referrals/${type}/:id`,
        name: `referrals.${type}.show`,
        view: 'referrals/tracking/Show',
        default: { params: { type } },
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryMiddleware, RequireUserMiddleware],
    })),
    ...[
        { type: 'received', action: 'update-slot' },
        { type: 'received', action: 'add-report' },
        { type: 'made', action: 'rate-referred' },
    ].map(({ type, action }) => ({
        path: `/referrals/${type}/:id/${action}`,
        name: `referrals.${type}.${action}`,
        view: 'referrals/tracking/Update',
        default: { params: { type, action } },
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryMiddleware, RequireUserMiddleware],
    })),
    {
        path: '/referrals/eprescribe',
        name: 'referrals.eprescribe',
        view: 'referrals/ePrescribe/Eprescribe',
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryMiddleware, RequireUserMiddleware],
    },
    {
        path: '/referrals/new',
        name: 'referrals.new',
        redirect: { name: `referrals.new.${newReferralSteps[0]}` },
    },
    ...newReferralSteps.map((step) => ({
        path: `/referrals/new/${step}`,
        name: `referrals.new.${step}`,
        view: `referrals/new/${ucfirst(step)}`,
        default: { query: { limit: 6 }, params: { step } },
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryMiddleware, RequireUserMiddleware],
    })),
    ...['received', 'made'].map((type) => ({
        path: `/referrals/${type}/:id/view-report`,
        name: `referrals.${type}.report`,
        view: 'referrals/tracking/ViewReport',
        default: { params: { type } },
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryMiddleware, RequireUserMiddleware],
    })),
    {
        path: '/referrals/ancillary-services-tests',
        name: 'referrals.services.tests',
        view: 'referrals/ancillary/AncillaryServiceTests',
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryMiddleware, RequireUserMiddleware],
    },
    {
        path: '/referrals/primary-care/:referralId/:signature',
        name: 'referrals.pc.insurance',
        view: 'referrals/tracking/PrimaryCareInsurance',
    },
]
